import qs from 'qs';
import type { IStringifyOptions } from 'qs';

export const parseSearch = <T extends object = object>(search: string): T =>
  qs.parse(search, { ignoreQueryPrefix: true, comma: true }) as T;

export const encodeQuery = (
  base: string,
  query?: object,
  options?: IStringifyOptions
) => {
  const opts = options || { arrayFormat: 'brackets' };
  return [base, query && qs.stringify(query, opts)].filter(Boolean).join('?');
};
